import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import {
  collection,
  doc,
  getDoc,
  limit,
  onSnapshot,
  orderBy,
  query,
  where
} from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import Menu from '../../panel/Menu';
import moment from 'moment';

function Checkouthistory() {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  });

  const [bookings, setbookings] = useState([]);
  const [username, setusername] = useState();
  const [userData, setUserData] = useState();
  const [loadincount, setloadincount] = useState(true);
  const [searchText, setsearchText] = useState("");

  // pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(10); // change this to allow user to pick rows per page

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      setUserData(user);
      fethUsers()
    });
  });

  const fethUsers = async () => {
    try {
      if (userData) {
        if (loadincount) {
          const docRef = doc(db, "users", userData.uid)
          const docSnap = await getDoc(docRef)
          if (docSnap.exists()) {
            setusername(docSnap.data().username);
            setloadincount(false)
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (searchText === '') {
      fetchData1()
    } else {
      fetchData2()
    }
  }, [searchText]);

  const fetchData1 = async () => {
    try {
      const q = query(
        collection(db, 'bookings'),
        where('status', '==', 'Checkout'),
        orderBy("checkoutdate", "desc"),
        limit(1000)
      )
      onSnapshot(q, (querySnapshot) => {
        setbookings(querySnapshot.docs.map(doc => ({
          id: doc.id,
          data: doc.data()
        })));
      });
    } catch (error) {
      Toast.fire({
        icon: "error",
        title: error.message
      });
    }
  }

  const fetchData2 = async () => {
    try {
      const filteredData = bookings.filter((item) =>
        item.data.customers.custname.toUpperCase().includes(searchText.toUpperCase()) ||
        item.data.customers.mobile.toUpperCase().includes(searchText.toUpperCase())
      );
      setbookings(filteredData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  // Pagination calculations
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = bookings.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(bookings.length / rowsPerPage);

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(prev => prev + 1);
  };

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage(prev => prev - 1);
  };

  return (
    <div>
      <Menu />
      <div className="content-wrapper" style={{ backgroundColor: '#fff' }}>
        <section className="content">
          <div className="container-fluid">
            <button className="btn btn-secondary " style={{ textTransform: "uppercase" }} >|| Checkout History ||</button>
            <div className="card card-primary card-outline mt-2">
              <div className=" p-1">
                <input
                  type="search"
                  value={searchText}
                  onChange={(e) => setsearchText(e.target.value)}
                  className='form-control col-sm-4'
                  placeholder='Type here......'
                />
              </div>
              <div className="card-body table-responsive p-0">
                <table className="table table-bordered table-hover table-striped table-head-fixed">
                  <thead>
                    <tr>
                      <th>Sr No</th>
                      <th>Invoice No </th>
                      <th>Customer Name </th>
                      <th>Mobile </th>
                      <th>Checkin Date </th>
                      <th>Checkout Date </th>
                      <th>Rooms </th>
                      <th style={{ textAlign: "right" }}>Total</th>
                      <th style={{ textAlign: "right" }}>Paid</th>
                      <th style={{ textAlign: "right" }}>Pending</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      currentRows.map((item, index) =>
                        <tr key={item.id}>
                          <td width="80">{indexOfFirstRow + index + 1}</td>
                          <td>{item.data.invoiceno}</td>
                          <td style={{ textTransform: "capitalize" }}>{item.data.customers.custname}</td>
                          <td>{item.data.customers.mobile} </td>
                          <td>{moment(item.data.checkindate).format('DD/MM/YYYY')}</td>
                          <td>{moment(item.data.checkoutdate).format('DD/MM/YYYY')}</td>
                          <td>
                            <div className='row'>
                              {item.data.rooms.map((item1, idx) =>
                                <span key={idx}>{item1.roomname} &nbsp;</span>
                              )}
                            </div>
                          </td>
                          <td style={{ textAlign: "right" }}>{parseFloat(item.data.totalamount).toFixed()}</td>
                          <td style={{ textAlign: "right" }}>{parseFloat(item.data.advance).toFixed()}</td>
                          <td style={{ textAlign: "right" }}>{parseFloat(item.data.remaining).toFixed()}</td>
                          <td>
                            <a href={'/print-invoice/' + item.id} className='btn btn-info btn-sm'>
                              <i className="fa fa-print"></i>
                            </a>
                          </td>
                        </tr>
                      )}
                  </tbody>
                </table>
              </div>

              {/* Pagination Controls */}
              <div className="card-footer d-flex justify-content-between align-items-center">
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={handlePrev}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
                <span>Page {currentPage} of {totalPages}</span>
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={handleNext}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </div>

            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default Checkouthistory;
